import axiosInstance from "../config/axiosConfig";

export const getResumenAnualTurnos = async (anio, pacienteID = null) => {
    const params = { anio };
    if (pacienteID) params.pacienteID = pacienteID;
    const response = await axiosInstance.get("/turnos/resumen-anual", { params });
    return response.data;
};
